"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ResumeParcelle_vue_1 = __importDefault(require("./ResumeParcelle.vue"));
var ResumeProprietaire_vue_1 = __importDefault(require("./ResumeProprietaire.vue"));
exports.default = {
    components: {
        ResumeParcelle: ResumeParcelle_vue_1.default,
        ResumeProprietaire: ResumeProprietaire_vue_1.default,
    },
    props: {
        value: Object,
        options: {
            type: Array,
            required: true
        },
        parcelles: Array,
    },
    mounted: function () {
        this.autoSelectTypeConvention();
    },
    methods: {
        getParcelle: function (identifier) {
            var parcelle = this.parcelles.find(function (p) { return p.Identifier === identifier; });
            return parcelle || {};
        },
        getProprietaire: function (identifier) {
            for (var _i = 0, _a = this.parcelles; _i < _a.length; _i++) {
                var parcelle = _a[_i];
                var proprietaire = parcelle.Proprietaires.find(function (p) { return p.Identifier === identifier; });
                if (proprietaire) {
                    return proprietaire;
                }
            }
            return {};
        },
        onChange: function () {
            var type = this.getSelected();
            if (!type || !type.IndemnitePossible) {
                this.value.MontantIndemnite = null;
            }
            this.$emit('input', this.value);
        },
        getSelected: function () {
            var _this = this;
            return this.options.find(function (o) { return o.Id == _this.value.TypeConvention; });
        },
        displayIndemnite: function () {
            var type = this.getSelected();
            return type && (type.IndemnitePossible || type.IndemniteObligatoire);
        },
        requireIndemnite: function () {
            var type = this.getSelected();
            return type && type.IndemniteObligatoire;
        },
        highlight: function (html) {
            // Si FAUX
            html = html.replace(/{{\^([^}]+)}}([^{]+){{\/\1}}/g, "<span style='color:red;background:rgba(0,0,0,0.1);' title='Si FAUX \"$1\"'>$2</span>");
            // Si VRAI
            html = html.replace(/{{#([^}]+)}}([^{]+){{\/\1}}/g, "<span style='color:green;background:rgba(0,0,0,0.1);' title='Si VRAI \"$1\"'>$2</span>");
            // Champ texte
            html = html.replace(/{{([^}]+)}}/g, "<span style='background:rgba(0,0,0,0.1);'>{{$1}}</span>");
            return html;
        },
        preview: function () {
            var selected = this.getSelected();
            var w = window.open("", "TemplatePreview", "width=900, height=900");
            w.document.body.innerHTML = this.highlight(selected.Content);
        },
        autoSelectTypeConvention: function () {
            if (this.options.length == 1) {
                this.value.TypeConvention = this.options[0].Id;
            }
        }
    },
    watch: {
        options: function () {
            this.autoSelectTypeConvention();
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/ConventionServitude/Components/GeneratedConvention.vue
// module id = 239
// module chunks = 0